import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../PageSection';
import { Grid, Typography } from '@mui/material';
import ImageZoom from '../ImageZoom';

const SplitTextImageSection = ({
  title,
  text,
  image,
  imageAlt,
  imageWidth,
  textSide,
  zoom,
  verticalImage,
  style,
  children,
}) => {
  const textItem = (
    <Grid item md={verticalImage ? 12 : 8} sm={12} xs={12}>
      <Typography variant={'h3'}>{title}</Typography>
      <Typography variant={'subtitle1'}>
        {text}
        {children}
      </Typography>
    </Grid>
  );

  return (
    <PageSection maxWidth={'md'} spacing={'slim'} style={style}>
      <Grid container spacing={2} p={2}>
        {textSide === 'start' ? textItem : null}

        <Grid item md={verticalImage ? 12 : 4} sm={12} xs={12}>
          <Grid direction={'row'} container alignItems="center" style={{ minHeight: '100%' }}>
            <Grid item>
              {zoom ? (
                <ImageZoom>
                  <img style={{ height: 'auto', width: imageWidth ? imageWidth : '100%' }} src={image} alt={imageAlt} />
                </ImageZoom>
              ) : (
                <img style={{ height: 'auto', width: imageWidth ? imageWidth : '100%' }} src={image} alt={imageAlt} />
              )}
            </Grid>
          </Grid>
        </Grid>

        {textSide === 'end' ? textItem : null}
      </Grid>
    </PageSection>
  );
};

SplitTextImageSection.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  image: PropTypes.string.isRequired,
  imageWidth: PropTypes.string,
  imageAlt: PropTypes.string.isRequired,
  textSide: PropTypes.oneOf(['start', 'end']),
  zoom: PropTypes.bool,
  verticalImage: PropTypes.bool,
};

SplitTextImageSection.defaultProps = {
  textSide: 'start',
  zoom: true,
  verticalImage: false,
};

export default SplitTextImageSection;
